import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { inittodoFB } from '../redux/actions';
import TodoItem from './TodoItem';


// type inittodo = {
//   createdAt: string,
//   title: string,  desc: string,  todoId: number,    
//   userId: number,    completed: string,   tags: string
// }

interface Props {
  todos: inittodoFB[],    
  uem: string, 
}

class TodoList extends PureComponent<Props> {
    constructor(props: Props){
        super(props);    
    }

      render(){
        const { todos, uem } = this.props;
        console.log( todos );
        if( !todos ){ return null; }
        return (
          <>
          <div className='todo-list'>{
            todos.map( (todo, i) => {
              return( <TodoItem key={i} todo={todo} uem={uem}/> )
            } )
          }
          {/* <div className="change-account-btn-wrapper">
            <Link to='/reactTodoSignIn' className='change-account-btn'> Change Account </Link>
          </div>             */}
          </div>
          <div className="change-account-btn-wrapper">
            <Link to='/reactTodoSignIn' className='change-account-btn'> Change Account </Link>
          </div>            
          </>      
        )
      }
    }

export default TodoList
